module.exports = __webpack_public_path__ + "static/projekt_indywidualny_d01-4f87a81bc0506f82f0602a384e1ab3c4.jpg";